/* Stabile IDs: kurze Zufalls-Strings (10 Zeichen, base36, ~51 Bit). Sie sind unabhängig von Reihenfolge und Sitzung,
 * werden als Kommentar in der .map gespeichert und können später von mehreren Nutzern gleichzeitig vergeben werden. */
import type { Entity } from './types.ts';

export const ID_RE = /^[a-z0-9]{6,24}$/;
const ID_CHARS = '0123456789abcdefghijklmnopqrstuvwxyz';

export function newId(): string {
  let s = '';
  const c = typeof globalThis.crypto?.getRandomValues === 'function' ? globalThis.crypto : null;
  const r = new Uint8Array(10);
  if (c) c.getRandomValues(r); else for (let i = 0; i < 10; i++) r[i] = Math.floor(Math.random() * 256);
  for (let i = 0; i < 10; i++) s += ID_CHARS[r[i] % 36];
  return s;
}
export const bumpId = (): void => {}; // alte Zähler-API, ohne Wirkung (Kompatibilität)
export const validId = (s: unknown): s is string => typeof s === 'string' && ID_RE.test(s);

/** Doppelte oder ungültige IDs durch neue ersetzen (z. B. nach Copy&Paste von Text). Liefert die Anzahl Korrekturen. */
export function dedupeIds(ents: Entity[]): number {
  const seen = new Set<string>(); let fixed = 0;
  const take = (o: { id: string }) => { if (!validId(o.id) || seen.has(o.id)) { o.id = newId(); fixed++; } seen.add(o.id); };
  ents.forEach((e) => { take(e); e.brushes.forEach((b) => take(b)); });
  return fixed;
}
